import React, { useEffect, useState } from 'react';

interface SidebarSection {
  id: string;
  title: string;
}

interface HelpSidebarProps {
  sections: SidebarSection[];
  activeSection: string;
  onSectionClick: (id: string) => void;
  isMobileMenuOpen?: boolean;
}

function HelpSidebar({ sections, activeSection, onSectionClick, isMobileMenuOpen = false }: HelpSidebarProps) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isMobileMenuOpen);
  }, [isMobileMenuOpen]);

  const handleSectionClick = (id: string) => {
    onSectionClick(id);
    // Close mobile menu after selection
    if (window.innerWidth < 1024) {
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Mobile toggle button */}
      <button
        className="help-sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle navigation menu"
      >
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
        <span>Navigation</span>
      </button>

      {/* Sidebar */}
      <aside className={`help-sidebar ${isOpen ? 'help-sidebar-open' : ''}`}>
        <nav className="help-sidebar-nav" aria-label="Help topics navigation">
          <ul className="help-sidebar-list">
            {sections.map((section) => (
              <li key={section.id}>
                <a
                  href={`#${section.id}`}
                  className={`help-sidebar-link ${activeSection === section.id ? 'help-sidebar-link-active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionClick(section.id);
                  }}
                  aria-current={activeSection === section.id ? 'location' : undefined}
                >
                  {section.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="help-sidebar-overlay"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}
    </>
  );
}

export default HelpSidebar;
